'use strict';

module.exports = function (ngModule) {
    ngModule.directive('makeTreeChart', require('./maketreechart'));
}


/** WEBPACK FOOTER **
 ** ./src/pages/directives/treechart/index.js
 **/